import React, { FC } from 'react';
import PasswordResetForm from 'FeatureModules/Auth/Components/Forms/PasswordResetForm';
import Container from 'FeatureModules/Setting/Components/Container';
import SettingsHeader from '../Components/SettingsHeader';

const SecuritySettings: FC = () => (
  <Container>
    <SettingsHeader title="Password" />
    <PasswordResetForm />
  </Container>
);

export default SecuritySettings;
